import { useState, useEffect, useCallback } from 'react';
import { Store } from '../types';
import ProductService from '../services/product-service';
import HttpClientRequest from '../api/client-request';

export const useStores = () => {
  const [stores, setStores] = useState<Store[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);


  const requestId = new Date().getTime().toString();

  const fetchProducts = useCallback(async () => {

    try {
      
      setLoading(true);
      const fetchedStores =  await ProductService.getStores(requestId);
      setStores(fetchedStores);
      
    } catch (error) {
      setError('Failed to fetch products');
    }
    finally {
      setLoading(false);
    }

  }, [requestId])

  useEffect(() => {

    void fetchProducts();

    return () => {
      
      HttpClientRequest.cancelRequest(requestId); // Cancel the request if needed

      setStores([]);
      setLoading(false);
      setError(null);
    }
  }, []);

  return { stores, loading, error };
};